import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.CurrentRaportsView.heading',
    defaultMessage: 'Bieżące raporty'
  },
  lastAdded: {
    id: 'views.CurrentRaportsView.lastAdded',
    defaultMessage: 'OSTATNIO DODANE'
  },
  nothingToShow: {
    id: 'views.CurrentRaportsView.nothingToShow',
    defaultMessage: 'Brak artykułów do wyświetlenia'
  },
  others: {
    id: 'views.CurrentRaportsView.others',
    defaultMessage: 'POZOSTAŁE'
  },
  categories: {
    id: 'views.CurrentRaportsView.categories',
    defaultMessage: 'KATEGORIE'
  },
  taxonomyAll: {
    id: 'views.CurrentRaportsView.categories.all',
    defaultMessage: 'Wszystkie'
  },
  publicationDate: {
    id: 'viewsCurrentRaportsView.publicationDate',
    defaultMessage: 'DATA PUBLIKACJI'
  },
  filter: {
    id: 'views.CurrentRaportsView.filter.all',
    defaultMessage: 'Wszystkie'
  },
  tag1: {
    id: 'views.CurrentRaportsView.tag1',
    defaultMessage: 'Case Studies'
  },
  tag2: {
    id: 'views.CurrentRaportsView.tag2',
    defaultMessage: 'Nasi eksperci'
  },
  tag3: {
    id: 'views.CurrentRaportsView.tag3',
    defaultMessage: 'Media o nas'
  },
  button: {
    id: 'views.CurrentRaportsView.button',
    defaultMessage: 'Zobacz więcej ...'
  },
  journalistContact: {
    id: 'views.CurrentRaportsView.journalistContact',
    defaultMessage: 'KONTAKT DLA DZIENNIKARZY'
  }
});



// WEBPACK FOOTER //
// ./src/views/CurrentReports/CurrentReportsView.intl.js